import { useEffect, useState } from "react";
import { ExemptedStudent, ThemeWrapper, VerityInstituteSettings } from "@verity/components";
import { CustomSettingData } from "../../settings-page";
import ExemptionSection from "../../../../../../../packages/components/src/editQuiz/edit-quiz-modals/exemptionModal";
import { OptionRelatedInstituteSettings, ProctoringOptionProfileV2 } from "@verity/proctoring-option/types";
import apiClient from "../../../../helpers/api-client";
import { Box } from "@mui/material";

export type InstitutionAccommodationProps = {
	profilesMap: Map<number, ProctoringOptionProfileV2>;
	optionRelatedInstituteSettings: OptionRelatedInstituteSettings | undefined;
	verityInstituteSettings: VerityInstituteSettings;
	exemptionInfo: {
		nonExemptRoster: Map<number, ExemptedStudent>;
		exemptRoster: Map<number, ExemptedStudent>;
	};
};

export const InstitutionAccommodationInput = (props: {
	loadData: InstitutionAccommodationProps;
	setting: CustomSettingData<Map<number, ExemptedStudent>>;
	onSettingChange: (value: Map<number, ExemptedStudent>) => void;
}) => {
	const [uploadedExemptedStudentsMap, setUploadedExemptedStudentsMap] = useState<Map<number, ExemptedStudent>>(
		new Map<number, ExemptedStudent>(props.loadData.exemptionInfo.exemptRoster),
	);

	const [profilesMap, setProfilesMap] = useState<Map<number, ProctoringOptionProfileV2>>(
		new Map<number, ProctoringOptionProfileV2>(props.loadData.profilesMap),
	);

	useEffect(() => {
		props.onSettingChange(uploadedExemptedStudentsMap);
	}, [uploadedExemptedStudentsMap, props]);

	const [exemptionInfo, setExemptionInfo] = useState<{
		nonExemptRoster: Map<number, ExemptedStudent>;
		exemptRoster: Map<number, ExemptedStudent>;
	}>(props.loadData.exemptionInfo);

	return (
		<ThemeWrapper>
			<Box overflow={"auto"}>
				<ExemptionSection
					loading={false}
					hasInstituteProfilePermissions={true}
					profilesMap={profilesMap}
					enforcedProfilesOnly={false}
					exemptionInfo={exemptionInfo}
					setExemptionInfo={setExemptionInfo}
					setUploadedExemptedStudentsMap={setUploadedExemptedStudentsMap}
					optionRelatedInstituteSettings={props.loadData.optionRelatedInstituteSettings}
					verityInstituteSettings={props.loadData.verityInstituteSettings}
					refreshProfiles={async () => {
						const profiles = await apiClient.proctoringProfile.getAll({});
						const refreshProfileMap = new Map(
							profiles
								.filter(
									(profile) =>
										(profile.proctoringOption.isExtension &&
											props.loadData.verityInstituteSettings.allowExtensionPlatform) ||
										(profile.proctoringOption.isLockdown &&
											props.loadData.verityInstituteSettings.allowLockdownPlatform) ||
										(profile.proctoringOption.isMobile && props.loadData.verityInstituteSettings.allowMobilePlatform),
								)
								.map((x) => [x.id, x]),
						);
						setProfilesMap(refreshProfileMap);
						return refreshProfileMap;
					}}
					setStudentsLoaded={() => {}}
					editInstitutionExemptions={true}
				/>
			</Box>
		</ThemeWrapper>
	);
};
